import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


import logo from './logo.svg';
import './App.css';
import BmiTwl from "./pages/bmi-twl";
import Visus from "./pages/visus";
import Iop from "./pages/iop";
import Bmi from "./pages/bmi";
import Waarden from "./pages/waarden";
import Charts from "./pages/charts";

const router = createBrowserRouter([
  {
    path: "/charts",
    element: <Charts/>,
  }

]);

function App() {
  return (
      <RouterProvider router={router} />
  );
}

export default App;
